"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var productListingDummy_1 = tslib_1.__importDefault(require("../productListing/productListingDummy"));
var getWidgetDummyData = function (widgetID) {
    switch (widgetID) {
        case 'banner_module':
        case 'bannerModule':
            return false;
        case 'listing':
        case 'product_listing':
        case 'productListing':
            return productListingDummy_1.default;
        default:
            return false;
    }
};
exports.default = getWidgetDummyData;
//# sourceMappingURL=getWidgetDummyData.js.map